import React, { useState, useEffect } from "react";

import axios from "axios";

import styled from "styled-components";

const Container = styled.div`
  width: 23%;
  height: 200px;
  border-radius: 5px;
  background: white;
  margin: 0 2% 2% 0;
  padding: 20px 0 0 0;
  text-align: center;
`;

const Image = styled.img`
  width: 50%;
  height: 60%;
  border-radius: 100%;
`;
const BrandTitle = styled.p`
  font-weight: 600;
`;

function Brand(props) {
  return (
    <Container>
      <Image src={props.brand.image} />
      <BrandTitle>{props.brand.name}</BrandTitle>
    </Container>
  );
}

export default Brand;
